import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ROUTES } from "@/shared/constants";
import { RouteLoadingFallback, SuspenseOutlet } from "@/shared/components";
import GuestLayout from "@/shared/components/layout/GuestLayout";
import TaasCardsDeck from "@/cards/common/TaasCardsDeck";
import LimitedEditionVerificationPage from "@/modules/limited-edition/LimitedEditionVerificationPage";
const CollectionCardPublicPage = lazy(
  () => import("@/cards/collection-card/component/CollectionCardPublicPage")
);

const ComingSoonPage = lazy(() => import("@/modules/sites/pages/ComingSoonPage"));
const SignInPage = lazy(() => import("@/modules/auth/pages/SignInPage"));
const LandingPage = lazy(() => import("@/modules/sites/pages/LandingPage"));
const RegisterPage = lazy(() => import("@/modules/auth/pages/RegisterPage"));
const RegisterOrganizationPage = lazy(
  () => import("@/modules/organization/pages/RegisterOrganizationPage")
);
const OrganizationHomePage = lazy(() =>
  import("@/modules/organization/pages/OrganizationHomePage").then((m) => ({
    default: m.OrganizationHomePage,
  }))
);
const OrganizationInvitesPage = lazy(() =>
  import("@/modules/organization/pages/OrganizationInvitesPage").then((m) => ({
    default: m.OrganizationInvitesPage,
  }))
);
const ForgotPasswordPage = lazy(() => import("@/modules/auth/pages/ForgotPasswordPage"));
const SupabaseAuthCallback = lazy(() => import("@/modules/auth/pages/SupabaseAuthCallback"));
const LobbyPage = lazy(() =>
  import("@/modules/tn/pages/LobbyPage").then((m) => ({ default: m.LobbyPage }))
);
const AvailableDeckCollectionPage = lazy(() =>
  import("@/modules/tn/pages").then((m) => ({ default: m.AvailableDeckCollectionPage }))
);
const TPPage = lazy(() => import("@/modules/tp/pages/TPPage").then((m) => ({ default: m.TPPage })));

export function GuestRoutes() {
  return (
    <Suspense fallback={<RouteLoadingFallback />}>
      <Routes>
        <Route element={<SuspenseOutlet />}>
          <Route path={ROUTES.SIGN_IN} element={<SignInPage />} />
          <Route path={ROUTES.COMING_SOON} element={<ComingSoonPage />} />
          <Route path={ROUTES.LANDING} element={<LandingPage />} />
          <Route path={ROUTES.HOME} element={<LandingPage />} />
          <Route path={ROUTES.TALENTS} element={<TPPage />} />
          <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
          <Route path={ROUTES.REGISTER_ORGANIZATION} element={<RegisterOrganizationPage />} />
          <Route path={ROUTES.ORGANIZATION_HOME} element={<OrganizationHomePage />} />
          <Route
            path={ROUTES.ORGANIZATION_HALL}
            element={
              <Navigate
                to={ROUTES.SIGN_IN}
                replace
                state={{ redirect: ROUTES.ORGANIZATION_HALL }}
              />
            }
          />
          <Route
            path={ROUTES.ORGANIZATION_LOBBY}
            element={
              <Navigate
                to={ROUTES.SIGN_IN}
                replace
                state={{ redirect: ROUTES.ORGANIZATION_LOBBY }}
              />
            }
          />
          <Route path={ROUTES.ORGANIZATION_INVITES} element={<OrganizationInvitesPage />} />
          <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
          <Route path={ROUTES.AUTH_CALLBACK} element={<SupabaseAuthCallback />} />
          <Route
            path={ROUTES.REGISTER_TALENT}
            element={
              <Navigate to={ROUTES.SIGN_IN} replace state={{ redirect: ROUTES.REGISTER_TALENT }} />
            }
          />
        </Route>

        <Route element={<GuestLayout />}>
          <Route element={<SuspenseOutlet />}>
            <Route path={ROUTES.LOBBY} element={<LobbyPage />} />
            <Route
              path={ROUTES.AVAILABLE_DECK_COLLECTIONS}
              element={<AvailableDeckCollectionPage />}
            />
            {/* // <Route path={ROUTES.LIMITED_EDITION} element={<LimitedEditionPage />} /> */}
            <Route path={ROUTES.LIMITED_EDITION} element={<LimitedEditionVerificationPage />} />
            <Route path={ROUTES.APP_CARD_DECK} element={<TaasCardsDeck />} />
            <Route path={ROUTES.COLLECTION_CARD_PUBLIC} element={<CollectionCardPublicPage />} />
            <Route path="*" element={<Navigate to={ROUTES.LOBBY} replace />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  );
}
